module.exports = __webpack_public_path__ + "static/media/trimex_granodeplata.2213419d.png";